module.exports = __webpack_public_path__ + "static/img/7.12eac26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/sp/7.png
// module id = X4ah
// module chunks = 0